export const lifecycleHandler = () => {};
